import { createSvgIcon } from '@material-ui/core';

export const LeftPanelOpenIcon = createSvgIcon(
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.37004 5.03708V10.963L11.333 8.00004L8.37004 5.03708ZM2.81449 14.6667C2.40708 14.6667 2.05832 14.5216 1.76819 14.2315C1.47807 13.9414 1.33301 13.5926 1.33301 13.1852V2.81486C1.33301 2.40745 1.47807 2.05868 1.76819 1.76856C2.05832 1.47844 2.40708 1.33337 2.81449 1.33337H13.1849C13.5923 1.33337 13.941 1.47844 14.2312 1.76856C14.5213 2.05868 14.6663 2.40745 14.6663 2.81486V13.1852C14.6663 13.5926 14.5213 13.9414 14.2312 14.2315C13.941 14.5216 13.5923 14.6667 13.1849 14.6667H2.81449ZM5.03671 13.1852V2.81486H2.81449V13.1852H5.03671ZM6.51819 13.1852H13.1849V2.81486H6.51819V13.1852Z"
      fill="currentColor"
    />
  </svg>,
  'LeftPanelOpenIcon',
);
